<template>
  <section class="page">
    <slide-y-down-transition
      :delay="50"
      appear
    >
      <div class="page--header">
        <LowerThird class="page--lowerthird" />
        <div class="page--header__after decors-background-fond-etoile" />
      </div>
    </slide-y-down-transition>
    <div>
      <ProductList
        ref="productlist"
        class="page--productlist"
        :teaser="true"
      />
      <transition
        name="fade"
        appear
      >
        <router-view ref="popin" />
      </transition>
      <SimpleButton
        to="/"
        class="page--backtohome"
      >
        {{ $config.common.backToHome }}
      </simplebutton>
    </div>
  </section>
</template>

<script>
import LowerThird from '@/components/common/lowerthird/LowerThird.vue';
import ProductList from '@/components/layouts/products/ProductList.vue';
import SimpleButton from '@/components/common/buttons/SimpleButton.vue';

export default {
  name: 'Teaser',
  components: {
    LowerThird,
    ProductList,
    SimpleButton,
  },

  data() {
    return {
    };
  },

  mounted() {
    console.log('mounted teaser', this.$currentWave, this.$config.common.maxWave);
    if (this.$currentWave >= this.$config.common.maxWave) {
      console.log('redirect to home');
      this.$router.push('/');
    }
  },
};
</script>
<style lang="stylus" scoped>
.page {

  &--header {
    margin: 0 auto;
    max-width: $container-width;
    width: calc(100% - var(--app-gutter));
    position: relative;

    &__after {
      position: absolute;
      top: 108px;
      border: 1px solid white;
      height: 320px;
      background-position: center;
      max-width: $container-width;
      width: 100%

      +mobile() {
        top: 92px;
        height: 320px;
      }
    }
  }

  &--lowerthird {
    margin: 0;
    padding: 0;
    z-index: 100;
    position: relative;
    width: 100%

    +mobile() {
      margin:0 auto 0;
    }
  }

  &--backtohome {
    margin: 50px auto 20px;
    +mobile() {
      margin-top: 20px auto 20px;
    }
  }
}
</style>
